import { type FormEvent, useState } from "react";
import { Banner, Button, Field, inputClass, Modal } from "../../components/ui";
import { errorMessage } from "../../lib/api";

/** Asks for the acknowledgment folio (optional) when marking a notice or zero report as filed. */
export function FilingDialog({
  open,
  title,
  description,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  description: string;
  pending: boolean;
  error: unknown;
  onConfirm: (folio: string) => void;
  onClose: () => void;
}) {
  const [folio, setFolio] = useState("");
  function submit(event: FormEvent) {
    event.preventDefault();
    onConfirm(folio.trim());
  }
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-gray-600">{description}</p>
        <Field
          label="Folio o número de acuse (opcional)"
          hint="El que muestra el portal del SAT al terminar la presentación."
        >
          {(id) => <input id={id} className={inputClass} value={folio} onChange={(e) => setFolio(e.target.value)} />}
        </Field>
        {error ? <Banner tone="error">{errorMessage(error)}</Banner> : null}
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit" loading={pending}>
            Marcar como presentado
          </Button>
        </div>
      </form>
    </Modal>
  );
}
